import {
    getDisplayedBudgetLineValue,
    getDisplayedCategoryMonthValue,
} from "./budgetActualsDisplay";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const csvCell = (value) => {
    const text = value === null || value === undefined ? "" : String(value);
    return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

const sum = (values) => values.reduce((total, value) => total + (Number(value) || 0), 0);

export const buildBudgetCsv = ({
    year,
    categories = [],
    actualsByMonth = [],
    actualsPresentByMonth = [],
    view = "actuals",
    closedMonths = [],
    netIncomeMonthValues = [],
}) => {
    const monthHeaders = MONTHS.map((month, index) => {
        const hasActuals = actualsPresentByMonth[index] ?? Boolean(actualsByMonth[index]?.lines);
        const state = view === "forecast"
            ? closedMonths[index] && !hasActuals ? "Closed" : "Forecast"
            : hasActuals ? "Actual" : closedMonths[index] ? "Closed" : "Forecast";
        return `${month} ${year} (${state})`;
    });
    const rows = [["COA", "Account Name", ...monthHeaders, "Total"]];

    (categories || []).forEach((category) => {
        const items = category.items || [];
        if (!items.length) return;

        rows.push([String(category.name || "").toUpperCase(), "", ...MONTHS.map(() => ""), ""]);
        items.forEach((item) => {
            const monthValues = MONTHS.map((_, index) => (
                getDisplayedBudgetLineValue(item, index, actualsByMonth, items)
            ));
            rows.push([
                item.accountNumber ?? item.account_number ?? "",
                item.accountName ?? item.account_name ?? "",
                ...monthValues,
                sum(monthValues),
            ]);
        });

        const categoryMonthValues = MONTHS.map((_, index) => (
            getDisplayedCategoryMonthValue(
                category.monthValues?.[index],
                items,
                index,
                actualsByMonth,
            )
        ));
        rows.push([
            `Total ${category.name || ""}`,
            "",
            ...categoryMonthValues,
            sum(categoryMonthValues),
        ]);
        rows.push(["", "", ...MONTHS.map(() => " "), " "]);
    });

    const netIncomeValues = MONTHS.map((_, index) => Number(netIncomeMonthValues[index]) || 0);
    rows.push(["NET INCOME", "", ...netIncomeValues, sum(netIncomeValues)]);

    return rows.map((row) => row.map(csvCell).join(",")).join("\n");
};
